import script from "./Block.vue?vue&type=script&setup=true&lang=ts"
export * from "./Block.vue?vue&type=script&setup=true&lang=ts"

import "./Block.vue?vue&type=style&index=0&id=aa84bc84&lang=scss"

const __exports__ = script;

export default __exports__